import settings from './settings';

const loggingEnabled = settings.logging.isEnabled();

/* eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars */
const _noop = (message: string): void => {};

const _logInfo = loggingEnabled
    ? (message: string): void => {
          /* eslint-disable-next-line no-console */
          console.info(message);
      }
    : _noop;

const _logWarn = loggingEnabled
    ? (message: string): void => {
          /* eslint-disable-next-line no-console */
          console.warn(message);
      }
    : _noop;

const _logError = loggingEnabled
    ? (message: string): void => {
          /* eslint-disable-next-line no-console */
          console.error(message);
      }
    : _noop;

const _logAssert = (condition: unknown, message?: string): void => {
    /* eslint-disable-next-line no-extra-boolean-cast */
    if (Boolean(condition)) {
        _logError(`Condition failed, ${message ?? ''}`);
    }
};

export default Object.freeze({
    info: _logInfo,
    warn: _logWarn,
    error: _logError,
    assert: _logAssert,
});
